import { get } from '../axios/axiosGateway';

export const getAll = (entities, params) => {
  return get(`/getall`, {
    entities: Array.isArray(entities) ? entities.join(',') : entities,
    ...params,
  });
};

export const placeholderGetAll = ({ page, pageSize }) => ({
  data: [],
  pagination: {
    totalRecords: 0,
    page,
    pageSize,
    pagesCount: 1,
  },
});
